import api from './httpClient';

const buildQuery = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') search.set(key, value);
  });
  const query = search.toString();
  return query ? `?${query}` : '';
};

export const fetchReviews = async (params) => {
  const res = await api.get(`/api/reviews${buildQuery(params)}`);
  return res.data;
};

export const updateReview = async (reviewId, payload) => {
  const res = await api.put(`/api/reviews/${reviewId}`, payload);
  return res.data;
};

export const deleteReview = async (reviewId) => {
  const res = await api.delete(`/api/reviews/${reviewId}`);
  return res.data;
};
